import styled from "@emotion/styled";

import { BaseLink } from "shared/components/common/base-link";
import { fontRoboto, fontSourceSerif4, theme } from "shared/lib/styles";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  justify-content: center;
  align-items: center;

  inline-size: 100%;

  ${theme.breakpoints.up("tablet")} {
    gap: 32px;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  justify-content: center;

  inline-size: 100%;

  ${theme.breakpoints.up("tablet")} {
    max-inline-size: 768px;
    margin-inline: auto;
  }
`;

export const BorderedContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  border-block: 2px solid #333333;

  padding-block: 16px;

  ${theme.breakpoints.up("tablet")} {
    gap: 16px;
  }

  ${theme.breakpoints.up("desktop")} {
    gap: 12px;
  }
`;

export const NewTag = styled.span`
  padding-block: 0;
  padding-inline: 2px;

  color: #ffffff;
  font-weight: 700;
  font-size: 14px;
  font-family: ${fontSourceSerif4};
  font-style: italic;
  line-height: normal;

  border-radius: 2px;

  background: #eb4254;
`;

export const StyledBaseLink = styled(BaseLink)`
  display: flex;
  gap: 8px;
  align-items: center;

  padding-block-end: 7px;

  color: #2c4692;
  font-weight: 700;
  font-size: 14px;
  font-family: ${fontSourceSerif4};
  font-style: italic;
  border-block-end: 1px dashed #2c4692;
`;

export const SeriesArticleSectionTag = styled.div`
  display: flex;
`;

export const Headline = styled.div`
  color: #000000;
  font-weight: 500;
  font-size: 24px;
  font-family: ${fontSourceSerif4};
  font-style: italic;
  line-height: 120%;
  letter-spacing: -0.6px;

  ${theme.breakpoints.up("tablet")} {
    font-size: 40px;
    letter-spacing: -1px;
  }
`;

export const SummaryAndActionWidget = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  ${theme.breakpoints.up("tablet")} {
    flex-direction: row;
    gap: 16px;
  }
`;

export const Summary = styled.div`
  color: #333333;
  font-weight: 400;
  font-size: 16px;
  font-family: ${fontRoboto};
  line-height: 150%;
  letter-spacing: -0.16px;
  font-variant-numeric: lining-nums proportional-nums;
`;

export const ActionWidget = styled.div`
  display: flex;
  gap: 16px;
  align-items: start;
`;

export const UpdatedDate = styled.div`
  color: #666666;
  font-weight: 400;
  font-size: 11px;
  font-family: ${fontRoboto};
  line-height: normal;

  ${theme.breakpoints.up("tablet")} {
    font-size: 14px;
  }
`;
